<span class="aurora-text relative inline-block align-middle" [style.width]="dimensions.width ? dimensions.width + 'px' : 'auto'"
    [style.height]="dimensions.height ? dimensions.height + 'px' : 'auto'">

    <!-- 隐藏的文本用于SEO -->
    <span class="sr-only">
        {{ncText}}
    </span>

    <!-- 视觉占位符 -->
    <span #textContent style="opacity: 0;display: inline-block; white-space: nowrap;"
        [style.position]="isReady ? 'absolute' : 'relative'" aria-hidden="true">
        {{ncText}}
    </span>

    <div class="absolute inset-0" [style.opacity]="isReady ? 1 : 0" style="transition: opacity 0.2s ease-in;"
        aria-hidden="true">

        <svg [attr.width]="dimensions.width" [attr.height]="dimensions.height" class="absolute inset-0">
            <defs>
                <clipPath [attr.id]="maskId">
                    <text #svgText x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
                        [attr.style]="getStyleString()">{{ncText}}</text>
                </clipPath>
            </defs>
        </svg>

        <canvas #canvas [style.clip-path]="'url(#' + maskId + ')'" [style.-webkit-clip-path]="'url(#' + maskId + ')'"
            class="h-full w-full">
        </canvas>
    </div>
</span>